import { createCustomTheme } from '@domains/subscription/theme'
import { Button, Dialog, Stack, ThemeProvider, Typography } from '@mui/material'

export interface ConfirmSelectSubscriptionPlanProps {
  open: boolean
  onConfirm: (options: { keepCustomerOverrides: boolean }) => void
  onCancel: () => void
  plan: string
}

export const ConfirmSelectSubscriptionPlan = ({ open, onConfirm, onCancel, plan }: ConfirmSelectSubscriptionPlanProps) => (
  <Dialog open={open} onClose={onCancel}>
    <ThemeProvider theme={createCustomTheme()}>
      <Stack
        sx={{
          gap: 3,
          padding: 3,
        }}
      >
        <Stack
          sx={{
            gap: 1,
          }}
        >
          <Typography data-testid="confirm-dialog-title" variant="h2">{`Confirm change subscription plan to ${plan}?`}</Typography>
          <Typography variant="p3Regular" color="textSecondary">
            Do you want to keep the current overrides on the subscription or reset them to the default values of the new subscription plan?
          </Typography>
        </Stack>
        <Stack
          sx={{
            alignSelf: 'flex-end',
            flexDirection: 'row',
            gap: 2,
          }}
        >
          <Button size="medium" data-testid="cancel-button" variant="tertiary" onClick={onCancel}>
            Cancel
          </Button>
          <Button
            size="medium"
            data-testid="reset-overrides-button"
            variant="outlined"
            color="error"
            onClick={() => onConfirm({ keepCustomerOverrides: false })}
          >
            Reset overrides
          </Button>
          <Button
            size="medium"
            data-testid="keep-overrides-button"
            variant="contained"
            onClick={() => onConfirm({ keepCustomerOverrides: true })}
          >
            Keep overrides
          </Button>
        </Stack>
      </Stack>
    </ThemeProvider>
  </Dialog>
)
